import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'antd';
import './NavCourse.css';
import { useTranslation } from 'react-i18next';

const NavCourse: React.FC = () => {
  const location = useLocation().pathname;
  const locationActive = location.slice(location.lastIndexOf('/') + 1);
  const { t } = useTranslation();

  const [selectedMenuItem, setSelectedMenuItem] = React.useState<string>('');
  const handleMenuClick = (e: any) => {
    setSelectedMenuItem(e.key);
  };

  useEffect(() => {
    setSelectedMenuItem(locationActive);
  }, [locationActive]);

  return (
    <aside className="site-layout__nav-course">
      <h2 className="nav-course__title">{t('courses.page_title')}</h2>
      <Menu
        selectedKeys={[selectedMenuItem]}
        mode="horizontal"
        onClick={(e) => handleMenuClick(e)}
      >
        <Menu.Item key="elsa-oxford">
          <Link to='/course/elsa-oxford'>Oxford Business Result</Link>
        </Menu.Item>
        <Menu.Item key="harper-collins">
          <Link to='/course/harper-collins'>Harper Collins</Link>
        </Menu.Item>
        <Menu.Item key="ielts">
          <Link to='/course/ielts'>IELTS</Link>
        </Menu.Item>
      </Menu>
    </aside>
  );
};

export default NavCourse;
